export enum BRAND {
  HOTPADS = 'hotpads',
  ZILLOW = 'zillow',
}
